import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { config } from '../../../config/index';
import AuthLayout from '../../../components/AuthLayout';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
const { API_URL, ASSOCIATE_URL } = config;

const SetupAccount = ({ location, history }) => {
  const token = queryString.parse(location.search).token;

  const [password, setPassword] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();

    let url = `${API_URL}/account/setup`;
    try {
      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          password,
          for_setup: true,
        }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        ToastUtil.success('Password is successfully set!');
        let response_data = await response.json();

        if (response_data.data.is_associate) {
          window.location.href = ASSOCIATE_URL;
        } else {
          history.push('/');
        }
      } else {
        ToastUtil.error('Failed to set password!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthLayout title="Set up your account" subtitle="Create your password to finish activating your workspace.">
        <form className="auth-form" onSubmit={(e) => submitHandler(e)}>
          <label>Password</label>
          <input
            className="form-control"
            type="password"
            placeholder="Set Password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit" className="btn btn-brand w-100">
            Submit
          </button>
        </form>
    </AuthLayout>
  );
};

export default withRouter(SetupAccount);
